import moment from 'moment';
import Swiper, {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
} from 'swiper';

import createCalendar from './createCalendar.js';
import {
  checkBroadcastDates,
  renderMainSchedule,
  showProgram,
} from './slides.js';

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar])

export default () => {
	const carouselOnAir = new Swiper('.carousel--on-air .carousel-container', {
		init: false,
		on: {
			init: function (e) {
				const currentTime = new Date().getHours() * 60 + new Date().getMinutes()
				let slideIndex = 0
				let shouldUpdate = true
				setTimeout(() => {
					e.slides.forEach((slide, index) => {
						const dataTime = slide.getAttribute('data-time')
						const time = dataTime.match(/\d+/g)
						const slideTime = +time[0] * 60 + +time[1]
						if (currentTime > slideTime && shouldUpdate) {
							slideIndex = index
						} else {
							shouldUpdate = false
						}
					})

					e.slideTo(slideIndex)
				}, 500)
			},
		},
		slidesPerView: 1,
		slidesPerColumn: 2,
		spaceBetween: 50,
		breakpoints: {
			1439: {
				slidesPerView: 4,
				slidesPerColumn: 1,
			},
			1200: {
				slidesPerView: 4,
				slidesPerColumn: 1,
			},
			980: {
				slidesPerView: 3,
				slidesPerColumn: 1,
			},
			640: {
				slidesPerView: 3,
				slidesPerColumn: 1,
				spaceBetween: 0,
			},
		},
	})

	const carouselPromo = new Swiper('.carousel--promo .carousel__container', {
		preloadImages: true,
		updateOnImagesReady: true,
		observer: true,
		observeSlideChildren: true,
		noSwiping: true,
		noSwipingClass: 'carousel--promo',
		navigation: {
			nextEl: '.carousel--promo .carousel__button--next',
			prevEl: '.carousel--promo .carousel__button--prev',
		},
		pagination: {
			el: '.carousel__pagination',
			type: 'bullets',
			clickable: true,
		},
		on: {
			slideChange: (swiper) => {
				const prevSlide = swiper.slides[swiper.previousIndex]
				const iframe = prevSlide.querySelector('iframe')
				const video = prevSlide.querySelector('video')

				if (iframe) {
					const src = iframe.src
					iframe.src = src
				}
				if (video) {
					video.pause()
				}
			},
		},
	})

	const carouselSchedule = new Swiper('.carousel--schedule .carousel-container', {
		init: false,
		navigation: {
			prevEl: '.carousel--schedule .carousel-button--prev',
			nextEl: '.carousel--schedule .carousel-button--next',
		},
		pagination: {
			el: '.carousel--schedule .carousel-pagination',
			clickable: true,
		},
		initialSlide: 7,
		slidesPerView: 2,
		breakpoints: {
			640: {
				slidesPerView: 3,
			},
			980: {
				slidesPerView: 4,
			},
		},
	})

	if (document.querySelector('.carousel--promo .carousel-container')) {
		carouselPromo.init()
	}

	if (document.querySelector('.carousel--on-air .carousel-container')) {
		carouselOnAir.on('init', (slider) => {
			renderMainSchedule(moment().format('YYYY-MM-DD'), slider)
		})
		carouselOnAir.init()
	}

	if (document.querySelector('.carousel--schedule .carousel-container')) {
		let excludeRange = []
		const minDate = moment().subtract(1, 'week').toDate()
		const maxDate = moment().add(2, 'weeks').toDate()

		const formattedMinDate = moment(minDate).format('YYYY-MM-DD')
		const formattedMaxDate = moment(maxDate).format('YYYY-MM-DD')

		carouselSchedule.on('init', (slider) => {
			const calendar = createCalendar(minDate, maxDate, excludeRange)

			slider.on('click', () => {
				if (slider.clickedSlide) {
					slider.slides.forEach((slide) => slide.childNodes[1].classList.remove('schedule-date--active'))
					slider.clickedSlide.childNodes[1].classList.add('schedule-date--active')

					const date = slider.clickedSlide.childNodes[1].getAttribute('data-date')
					showProgram(date)
					calendar.setDate(date)
				}
			})
		})

		checkBroadcastDates(formattedMinDate, formattedMaxDate).then((data) => {
			excludeRange = data
			carouselSchedule.init()
		})
	}
}

const air = document.querySelector('.carousel--on-air	 .carousel__container')?.swiper
const schedule = document.querySelector('.carousel--schedule .carousel__container')?.swiper
const promo = document.querySelector('.carousel--promo .carousel__container')?.swiper

let i = 1
const timer = setInterval(() => {
	schedule?.update()
	air?.update()
	promo?.updateAutoHeight()
	i += 1
	if (i === 20) clearInterval(timer)
}, 100)
